"use client";
import { FaFilter } from "react-icons/fa";
import { PIN_POSITIONS } from "./constants";

const TableHeader = ({
  columns,
  columnWidths,
  handleResizeStart,
  selectedRows,
  paginatedData,
  handleSelectAll,
  activeFilters,
  onFilterClick,
  showRowSelection,
  showActions,
}) => {
  // Group columns by pin position
  const leftPinnedColumns = columns.filter(
    (col) => col.pin === PIN_POSITIONS.LEFT
  );
  const rightPinnedColumns = columns.filter(
    (col) => col.pin === PIN_POSITIONS.RIGHT
  );
  const unpinnedColumns = columns.filter(
    (col) => !col.pin || col.pin === PIN_POSITIONS.NONE
  );

  // Render header cell
  const renderHeaderCell = (column, index) => {
    const isPinned = column.pin && column.pin !== PIN_POSITIONS.NONE;
    const hasActiveFilter =
      activeFilters &&
      activeFilters[column.key] &&
      activeFilters[column.key].length > 0;

    return (
      <th
        key={column.key}
        className={`px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50 ${
          isPinned
            ? `sticky ${
                column.pin === PIN_POSITIONS.LEFT ? "left-0" : "right-0"
              } z-10`
            : ""
        }`}
        style={{
          width: columnWidths[column.key],
          position: isPinned ? "sticky" : "relative",
        }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer">{column.label}</div>

          {column.filter && (
            <div
              className={`ml-2 ${
                hasActiveFilter ? "text-primary" : "text-gray-400"
              } cursor-pointer`}
              onClick={() => onFilterClick(column)}
            >
              <FaFilter />
            </div>
          )}

          <div
            className="absolute right-0 top-0 h-full w-1 border-r cursor-col-resize"
            onMouseDown={(e) => handleResizeStart(e, column.key)}
          />
        </div>
      </th>
    );
  };

  return (
    <thead>
      <tr>
        {showRowSelection && (
          <th className="w-10 px-4 py-3 bg-gray-50">
            <input
              type="checkbox"
              checked={selectedRows?.length > 0}
              onChange={handleSelectAll}
              className="h-4 w-4 text-primary border-gray-300 rounded"
            />
          </th>
        )}

        {leftPinnedColumns.map(renderHeaderCell)}
        {unpinnedColumns.map(renderHeaderCell)}
        {rightPinnedColumns.map(renderHeaderCell)}
        {showActions && (
          <th className="w-24 px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50 sticky right-0 z-10">
            Actions
          </th>
        )}
      </tr>
    </thead>
  );
};

export default TableHeader;
